import React, {useEffect, useState} from "react";
import {inputOnChange} from "../../commonmethod/simmsInputMethod";
import SimmsInput from "../../input/SimmsInput";
import SimmsTextArea from "../../input/SimmsTextArea";
import BtnsCreateFixed from "../../buttons/BtnsCreateFixed";
import CustomSelectBox from "../../select/CustomSelectBox";
import {createCustomCode, createCustomString, getGroupSelectListField} from "../../../api/field/CustomCodeService";
import {handleActiveError, handleActiveToast} from "../../sonner/ToastBasic";
import {CacheType} from "../../../constant/CodeSpecNum";
import {useCacheRefresh} from "../../../hooks/useCacheRefresh";
import {createFiled} from "../../../api/field/FieldService";

// 공통코드, 필드 영역
export function CustomDataContainer({ onClose, onCreate, ...props }) {
    const [data, setData] = useState({});
    const refreshCache = useCacheRefresh();

    const customType=[
        {id:'INPUT', name:"INPUT"},
        {id:'TEXT', name:"TEXT"},
        {id:'DATE', name:"DATE"},
        {id:'CODE', name:"CODE"}
    ]

    const createHandler = async (e) => {
        try {
            const _ = e.customType === 'CODE' ? await createCustomCode(e) : await createCustomString(e);
            if (_.status === 200) {
                refreshCache(CacheType.customCode);
                onCreate?.();

                handleActiveToast({
                    description: "", message: "등록 되었습니다.", labelListener: () => {
                    }
                })
            } else if (_.status === 201 || (_.status === 202)) {
                handleActiveError({message: _.data.title, description: _.data.reason});
            } else {
                console.log(_)
                handleActiveToast({
                    description: "알 수 없는 에러.", message: "등록할 수 없습니다..", labelListener: () => {
                    }
                })
            }
        } catch (error) {

        }
    }

    return (
        <div className="space-y-3">
            <table className="w-full border table-fixed border-collapse">
                <colgroup>
                    <col className="w-[100px]" />
                    <col className="w-auto" />
                </colgroup>

                <tbody>
                    <tr>
                        <th>필드명 <span className="c-red">*</span></th>
                        <td className={"p-1"}>
                            <SimmsInput onChange={(v) => inputOnChange(setData, "name", v, true)} data={data.name} style={{width: "calc(100% - 5px)"}} />
                        </td>
                    </tr>
                    <tr>
                        <th>상세설명</th>
                        <td className={"p-1"}>
                            <SimmsTextArea onChange={(v) => inputOnChange(setData, "description", v, false)} data={data.description} style={{minHeight: "80px", width: "calc(100% - 5px)"}} />
                        </td>
                    </tr>
                    <tr>
                        <th>타입 <span className="c-red">*</span></th>
                        <td className={"p-1"}>
                            <CustomSelectBox target={'customType'} options={customType} setter={setData} />
                        </td>
                    </tr>
                </tbody>
            </table>

            <BtnsCreateFixed create={() => createHandler(data)} />
        </div>
    );
}

// 그룹필드 영역
export function CustomFieldContainer({ onClose, onCreate, ...props }) {
    const [data, setData] = useState({...props});

    const fieldType=[
        {id: null, name:"선택"},
        {id:'INPUT', name:"INPUT"},
        {id:'TEXT', name:"TEXT"},
        {id:'DATE', name:"DATE"},
        {id:'USER', name:"USER"},
        {id:'SELECT', name:"SELECT"},
    ]

    async function createHandler(){
        if(!data.title){
            alert('필드명을 입력하세요.')
            return;
        }
        if(!data.type){
            alert('타입 선택은 필수입니다.')
            return;
        }
        if(data.type=='SELECT' && !data.entity){
            alert('코드 종류를 선택하세요')
            return;
        }
        const _ = await createFiled(data);

        if (_.status === 200) {
            onCreate?.();
            handleActiveToast({
                description: "", message: "등록 되었습니다.", labelListener: () => {
                }
            })
        }else if(_.status ===201 ||(_.status === 202)){
            handleActiveError({message: _.data.title, description: _.data.reason});
        }else  {
            console.log(_)
            handleActiveToast({
                description: "알 수 없는 에러.", message: " 등록할 수 없습니다..", labelListener: () => {
                }
            })
        }
    }

    const [groupSelect, setGroupSelect] =useState([]);

    async function getGroups() {
        return  await getGroupSelectListField();
    }

    useEffect(() => {
        getGroups().then(r => setGroupSelect([  {id: null, name:"선택"},...r.data]))
    }, [])

    useEffect(() => {
        if (data?.type !== 'SELECT') {
            setData(({ entity, ...rest }) => rest);
        }
    }, [data.type]);

    return (
        <div className="space-y-3">
            <table className="w-full border table-fixed border-collapse">
                <colgroup>
                    <col className="w-[100px] min-h-[40px]" />
                    <col className="w-auto" />
                </colgroup>

                <tbody>
                    <tr>
                        <th className={"py-[7px]"}>자산그룹명</th>
                        <td className={"p-1"}>{data.code.name}</td>
                    </tr>
                    <tr>
                        <th>필드명 <span className="c-red">*</span></th>
                        <td className={"p-1"}>
                            <SimmsInput onChange={(v) => inputOnChange(setData, "title", v, true)} data={data.title} style={{width: "calc(100% - 5px)"}} />
                        </td>
                    </tr>
                    <tr>
                        <th>타입 <span className="c-red">*</span></th>
                        <td className={"p-1"}>
                            <CustomSelectBox target={'type'} options={fieldType} setter={setData} />
                        </td>
                    </tr>
                    {
                        data.type == 'SELECT' &&
                        <tr>
                            <th>선택 목록 <span className="c-red">*</span></th>
                            <td className={"p-1"}>
                                <CustomSelectBox target={'entity'} options={groupSelect} setter={setData} />
                            </td>
                        </tr>
                    }
                </tbody>
            </table>

            <BtnsCreateFixed create={() => createHandler(data)} />
        </div>
    );
}

export function CustomDataButtonTrigger({ openDrawer }) {
    return (
        <div className="flex justify-center items-center w-full h-full cursor-pointer hover:bg-gray-100 rounded" onClick={openDrawer}>
            <span className="text-lg font-semibold leading-none">+</span>
        </div>
    );
}